export default __webpack_public_path__ + "static/media/fpa10000.71a773a3.png";